export const currencyValidator = {
    format: (num: number): string => {
        return num.toFixed(2);
    },
    parse: function(newString: string, oldNumber: number) {
        interface ParseResult {
            value: number;
        }

        class CleanParse implements ParseResult {
            value: number;

            constructor(value: number) {
                this.value = value;
            }
        }

        class CurrencyWarning implements ParseResult {
            warning: string;
            value: number;

            constructor(warning: string, value: number) {
                this.warning = warning;
                this.value = value;
            }
        }

        class NotAValidAmountWarning extends CurrencyWarning {
            constructor(value: number) {
                super(newString + " is not a valid sterling amount", value);
            }
        }

        class AutomaticConversionWarning extends CurrencyWarning {
            constructor(value: number) {
                super(newString + " was automatically converted to " + value, value);
            }
        }

        // remove minus signs as we don't support negative values
        newString = newString.replace('-', '');
        const newNumber = Number(newString);
        const indexOfDot = newString.indexOf(".");
        const indexOfE = newString.indexOf("e");

        if (isNaN(newNumber)) {
            if (
                indexOfDot === -1 &&
                indexOfE > 0 &&
                indexOfE === newString.length - 1 &&
                Number(newString.slice(0, indexOfE)) !== 0
            ) {
                return new CleanParse(oldNumber);
            } else {
                // @ts-ignore
                return new NotAValidDollarAmountWarning(oldNumber);
            }
        }

        const newCurrencyString = currencyValidator.format(newNumber);
        const newCurrencyNumber = Number(newCurrencyString);

        if (newCurrencyNumber === newNumber) {
            if (indexOfE !== -1 && indexOfE === newString.length - 2) {
                return new AutomaticConversionWarning(newNumber);
            } else {
                return new CleanParse(newNumber);
            }
        } else {
            return new NotAValidAmountWarning(
                newNumber > newCurrencyNumber ? newCurrencyNumber : oldNumber
            );
        }
    }
};
